/* Tictox retail sections: scroll reveal. Safe to include multiple times. */
(function () {
  if (window.__txRetailInit) return;
  window.__txRetailInit = true;

  function reveal() {
    var els = document.querySelectorAll('.tx-reveal:not(.is-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || document.documentElement.classList.contains('shopify-design-mode')) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal); else reveal();
  document.addEventListener('shopify:section:load', reveal);
})();

/* Stable #faq anchor: Dawn's FAQ section id changes per template, so tag the first FAQ block on the page. */
(function () {
  var faq = document.querySelector('.collapsible-content');
  if (faq && !document.getElementById('faq')) {
    var wrap = faq.closest('.shopify-section') || faq;
    wrap.id = wrap.id || 'faq';
    var a = document.createElement('span'); a.id = 'faq'; a.style.cssText = 'position:relative;top:-90px;display:block;height:0;';
    wrap.insertBefore(a, wrap.firstChild);
    if (location.hash === '#faq') { requestAnimationFrame(function () { a.scrollIntoView(); }); }
  }
})();
